const validateEmail = (value) => {
  let error;

  if (!value) {
    error = "required field";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]$/i.test(value)) {
    error = "Invalid email address";
  }

  return error;
};

export default validateEmail;
